export default __webpack_public_path__ + "static/media/sleep-well-pepe.4b10a6e6.jpeg";